import { SoilLayerWidget } from './Components/SoilLayerWidget';

export default SoilLayerWidget;
